const supportedPlatforms = Object.freeze({
  YOUTUBE: 'youtube',
  VIMEO: 'vimeo',
})

const platforms = {
  [supportedPlatforms.YOUTUBE]: {
    regex: /(?:https?:\/\/)?(?:www\.)?youtu(.be\/|be\.com\/watch\?v=)([^#&\n]{8,})/i,
    regexIdGroupIndex: 2,
    buildEmbedUrl(id) {
      return `https://www.youtube.com/embed/${id}`
    },
    extractId(url) {
      const regexGroups = this.regex.exec(url)
      return regexGroups[this.regexIdGroupIndex]
    },
  },
  [supportedPlatforms.VIMEO]: {
    regex: /(?:https?:\/\/)?(?:www\.)?(vimeo)\.com\/(\d+)/i,
    regexIdGroupIndex: 2,
    buildEmbedUrl(id) {
      return `https://player.vimeo.com/video/${id}`
    },
    extractId(url) {
      const regexGroups = this.regex.exec(url)
      return regexGroups[this.regexIdGroupIndex]
    },
  },
}

export default {
  isEmbeddable(url) {
    return url ? this.isYoutube(url) || this.isVimeo(url) : false
  },
  isYoutube(url) {
    return url ? !!url.match(platforms[supportedPlatforms.YOUTUBE].regex) : false
  },
  isVimeo(url) {
    return url ? !!url.match(platforms[supportedPlatforms.VIMEO].regex) : false
  },
  buildUrl(url) {
    if (url && this.isVimeo(url)) {
      const videoId = platforms[supportedPlatforms.VIMEO].extractId(url)
      return platforms[supportedPlatforms.VIMEO].buildEmbedUrl(videoId)
    } else if (url && this.isYoutube(url)) {
      const videoId = platforms[supportedPlatforms.YOUTUBE].extractId(url)
      return platforms[supportedPlatforms.YOUTUBE].buildEmbedUrl(videoId)
    } else {
      return url
    }
  },
}
